import "./editNoteBook.scss";
import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { EditNote } from "../../services/noteBookService";
import IconButton from "../iconButton/iconButton"
import CheckIcon from "../../assets/images/check.svg";
import CloseIcon from "../../assets/images/closeCancel.svg";

export default function EditNooteBook({text, noteId, onCancel, afterEditNote}) {
  const textareaRef = useRef(null);
  const [note, setNote] = useState(text);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      // یک تیک صبر می‌کنیم تا textarea با مقدار جدید رندر شود
      requestAnimationFrame(() => {
        const el = textareaRef.current;
        if (!el) return;
        el.focus();
        const len = el.value.length;
        el.setSelectionRange(len, len);
        autoGrow(el);
      });
  }, []);

  const autoGrow = (el) => {
    if (!el) return;
    el.style.height = "0px";                 // ریست
    el.style.height = el.scrollHeight + "px"; // اندازه واقعی
  };

  const handleEditNote = (e) => {
    setNote(e.target.value);
    autoGrow(e.target)
  }
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      onCancel();
    }
    if (e.key === "Enter" && e.ctrlKey) {
      e.preventDefault();
      editNote();
    }
  }

  const editNote = async () => {
    if (note !== "") {
      try {
        setLoading(true);
        await EditNote(noteId, note);
        setLoading(false);
        setNote("");
        afterEditNote();
      } catch (err) {
        setLoading(false);
        toast.error(err.error, { toastId: "error" });
      }
    }
  }

  return (
    <div className="editNoteBook">
      <textarea
        className="editNoteTextarea"
        ref={textareaRef} 
        onChange={ (e) => handleEditNote(e)}
        value={note}
        onInput={(e) => autoGrow(e.target)}
        rows={1}
        onKeyDown = {e=>handleKeyDown(e)}

      >
      </textarea>
      <div className="editNoteIconWrapper">
        <IconButton icon={CheckIcon} tooltip="ثبت" onClick={() => editNote()} loading={loading} className="editNoteButton" />
        <IconButton icon={CloseIcon} tooltip="بیخیال" onClick={() => onCancel()} className="editNoteButton" />
      </div>
    </div>
  );
}
